// PDP select_content events
if (document.body.dataset.pageType === 'product') {

  function pushSelectContentEvent(eventData) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    if (typeof Shopify !== 'undefined' && Shopify.analytics) {
      Shopify.analytics.publish('custom_event', eventData);
    }
  }

  function pushSelectItemEvent(eventData) {
    pushEcommerceEvent(eventData);
  }

  function pushViewItemListEvent(eventData) {
    pushEcommerceEvent(eventData);
  }

  function pushEcommerceEvent(eventData) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);

    if (typeof Shopify !== 'undefined' && Shopify.analytics) {
      Shopify.analytics.publish('custom_event', eventData);
    }
  }

  function parseDisplayedPrice(element) {
    if (!element) {
      return 0;
    }

    const text = element.textContent.replace(/\s+/g, ' ').trim();
    const match = text.match(/[\d]+(?:[.,]\d+)?/);

    if (!match) {
      return 0;
    }

    return parseFloat(match[0].replace(',', '.')) || 0;
  }

  function centsToMajorUnits(value) {
    const amount = Number(value);

    if (!Number.isFinite(amount) || amount <= 0) {
      return 0;
    }

    return Math.round((amount / 100) * 100) / 100;
  }

  function getPdpItemListId(bundleSection) {
    return (
      bundleSection?.dataset.itemListId ||
      document.querySelector('.product-info buy-buttons[data-current-product-id]')?.getAttribute('data-current-product-id') ||
      document.querySelector('.product-gallery [data-productid]')?.getAttribute('data-productid') ||
      ''
    );
  }

  function getBundleListName(bundleSection, productCard) {
    const listName =
      bundleSection?.dataset.itemListName ||
      productCard?.getAttribute('data-gtm-list-name') ||
      bundleSection?.querySelector('.bundle_wrapper .title')?.textContent ||
      '';

    return normalizeLinkText(listName);
  }

  function getCompraloConCardIndex(productCard, bundleSection) {
    const cards = Array.from(bundleSection.querySelectorAll('product-card.product-card'));

    return Math.max(1, cards.indexOf(productCard) + 1);
  }

  function getCompraloConPrices(productCard) {
    const priceFromData = centsToMajorUnits(productCard.getAttribute('data-gtm-price'));
    const compareFromData = centsToMajorUnits(productCard.getAttribute('data-gtm-compare-at-price'));

    if (priceFromData > 0) {
      const priceOriginal = compareFromData > 0 ? compareFromData : priceFromData;

      return {
        price: priceFromData,
        priceOriginal,
        discount: Math.max(0, Math.round((priceOriginal - priceFromData) * 100) / 100),
      };
    }

    const price = parseDisplayedPrice(productCard.querySelector('sale-price'));
    const priceOriginal = parseDisplayedPrice(productCard.querySelector('compare-at-price')) || price;

    return {
      price,
      priceOriginal,
      discount: Math.max(0, Math.round((priceOriginal - price) * 100) / 100),
    };
  }

  function buildCompraloConItemFromCard(productCard, bundleSection) {
    const prices = getCompraloConPrices(productCard);
    const variantId = productCard.getAttribute('data-variant-id');
    const currency = productCard.getAttribute('data-currency') || 'EUR';
    const index = Number(productCard.getAttribute('data-product-index')) || getCompraloConCardIndex(productCard, bundleSection);

    return {
      item_name: normalizeLinkText(productCard.getAttribute('handle') || ''),
      item_id: productCard.getAttribute('data-product-sku') || '',
      index,
      price_original: prices.priceOriginal,
      price: prices.price,
      discount: prices.discount,
      coupon: null,
      currency,
      item_category: normalizeLinkText(productCard.getAttribute('data-gtm-item-category') || productCard.getAttribute('data-product-type') || ''),
      item_category2: normalizeLinkText(productCard.getAttribute('data-gtm-item-category2') || ''),
      item_category3: normalizeLinkText(productCard.getAttribute('data-gtm-item-category3') || ''),
      item_category4: normalizeLinkText(productCard.getAttribute('data-gtm-item-category4') || productCard.getAttribute('data-product-variant') || ''),
      item_variant: variantId ? `variant=${variantId}` : '',
    };
  }

  function buildCompraloConItem(productCard, bundleSection, productLink) {
    const item = buildCompraloConItemFromCard(productCard, bundleSection);

    return {
      ...item,
      url_destination: getAbsoluteUrl(productLink.getAttribute('href')),
      value: item.price,
    };
  }

  function trackPdpBundleViewItemList(bundleSection) {
    if (bundleSection.dataset.gtmViewItemListTracked === 'true') {
      return;
    }

    const itemListName = getBundleListName(bundleSection);
    const productCards = Array.from(bundleSection.querySelectorAll('product-card.product-card'));
    const items = productCards
      .map((productCard) => buildCompraloConItemFromCard(productCard, bundleSection))
      .filter((item) => item.item_name);

    if (!itemListName || !items.length) {
      return;
    }

    const totalValue = Math.round(items.reduce((sum, item) => sum + item.price, 0) * 100) / 100;

    pushViewItemListEvent({
      event: 'view_item_list',
      ecommerce: {
        item_list_name: itemListName,
        item_list_id: String(getPdpItemListId(bundleSection)),
        value: totalValue,
        items,
      },
    });

    bundleSection.dataset.gtmViewItemListTracked = 'true';
  }

  function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();

    return rect.bottom > 0 && rect.top < window.innerHeight && rect.width > 0 && rect.height > 0;
  }

  function initPdpBundleViewItemListTracking() {
    const bundleSections = document.querySelectorAll('.pdp_bundle');

    if (!bundleSections.length) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          trackPdpBundleViewItemList(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '100px 0px' }
    );

    bundleSections.forEach((bundleSection) => {
      if (bundleSection.dataset.gtmViewItemListTracked === 'true') {
        return;
      }

      if (isElementInViewport(bundleSection)) {
        trackPdpBundleViewItemList(bundleSection);
        return;
      }

      observer.observe(bundleSection);
    });
  }

  function pushCompraloConSelectItem(event) {
    const bundleSection = event.target.closest('.pdp_bundle');

    if (!bundleSection) {
      return;
    }

    if (event.target.closest('.product-card__quick-add-button, .js-size-button, buy-buttons')) {
      return;
    }

    const productLink = event.target.closest('.product-card a[href*="/products/"]');

    if (!productLink) {
      return;
    }

    const productCard = productLink.closest('product-card.product-card');

    if (!productCard) {
      return;
    }

    const item = buildCompraloConItem(productCard, bundleSection, productLink);
    const itemListName = getBundleListName(bundleSection, productCard);

    if (!item.item_name || !itemListName) {
      return;
    }

    pushSelectItemEvent({
      event: 'select_item',
      action_type: 'click_on_card',
      url_destination: item.url_destination,
      ecommerce: {
        item_list_name: itemListName,
        item_list_id: String(getPdpItemListId(bundleSection)),
        value: item.value,
        currency: item.currency,
        items: [
          {
            item_name: item.item_name,
            item_id: item.item_id,
            index: item.index,
            price_original: item.price_original,
            price: item.price,
            discount: item.discount,
            coupon: item.coupon,
            currency: item.currency,
            item_category: item.item_category,
            item_category2: item.item_category2,
            item_category3: item.item_category3,
            item_category4: item.item_category4,
            item_variant: item.item_variant,
          },
        ],
      },
    });
  }

  function normalizeLinkText(text) {
    return text
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')
      .toLowerCase();
  }

  function getAccordionTabText(summary) {
    const toggle = summary.querySelector('.accordion__toggle');

    if (!toggle) {
      return '';
    }

    const clone = toggle.cloneNode(true);
    clone.querySelector('.animated-plus')?.remove();
    clone.querySelector('[aria-hidden="true"]')?.remove();

    return normalizeLinkText(clone.textContent);
  }

  function getGalleryImageIndex(gallery, detailIndex) {
    const carousel = gallery.querySelector('.product-gallery__carousel');

    if (!carousel) {
      return 0;
    }

    const imageCells = carousel.cells.filter((cell) => cell.getAttribute('data-media-type') === 'image');
    const selectedImageIndex = imageCells.indexOf(carousel.selectedCell);

    if (typeof detailIndex === 'number' && detailIndex >= 0 && detailIndex < imageCells.length) {
      if (detailIndex === carousel.selectedIndex && selectedImageIndex >= 0 && detailIndex !== selectedImageIndex) {
        return selectedImageIndex;
      }

      return detailIndex;
    }

    return Math.max(0, selectedImageIndex);
  }

  function getImagePosition(index) {
    return `image_${String(index).padStart(2, '0')}`;
  }

  const SIZE_LINK_TEXT_BY_ID = {
    'szb-vfr-button': 'encuentra_tu_talla',
    'szb-measurements-button': 'guia_de_tallas',
  };

  function pushSizeLinkEvent(button) {
    const linkText = SIZE_LINK_TEXT_BY_ID[button.id];

    if (!linkText) {
      return;
    }

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'click_on_link',
      element: 'link',
      position: 'tallas',
      link_text: linkText,
      url_destination: null,
    });
  }

  function getAbsoluteUrl(url) {
    if (!url) {
      return window.location.href;
    }

    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return window.location.href;
    }
  }

  function getColorNameFromSwatch(swatch) {
    return swatch.getAttribute('data-tooltip') || swatch.querySelector('.sr-only')?.textContent || swatch.textContent;
  }

  function isColorOptionFieldset(fieldset) {
    const optionClass = Array.from(fieldset.classList).find((className) => {
      return !className.startsWith('variant-picker') && !['v-stack', 'gap-2', 'no-js:hidden', 'wrap', 'h-stack', 'gap-2.5'].includes(className);
    });

    return ['color', 'colour', 'couleur', 'colore', 'farbe'].includes(optionClass?.toLowerCase());
  }

  const SIZE_OPTION_NAMES = ['size', 'talla', 'taille', 'groesse', 'größe', 'taglia', 'tamanho'];

  function getFieldsetOptionName(fieldset) {
    const legendName = fieldset.querySelector('legend')?.textContent.replace(':', '').trim().toLowerCase();

    if (legendName) {
      return legendName;
    }

    const optionClass = Array.from(fieldset.classList).find((className) => {
      return !className.startsWith('variant-picker') && !['v-stack', 'gap-2', 'no-js:hidden', 'wrap', 'h-stack', 'gap-2.5'].includes(className);
    });

    return optionClass?.toLowerCase() || '';
  }

  function isSizeOptionFieldset(fieldset) {
    const optionName = getFieldsetOptionName(fieldset);

    return SIZE_OPTION_NAMES.some((sizeName) => optionName === sizeName || optionName.includes(sizeName));
  }

  function isDesktopViewport() {
    if (window.themeVariables?.mediaQueries?.md) {
      return window.matchMedia(window.themeVariables.mediaQueries.md).matches;
    }

    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function isMobileViewport() {
    return !isDesktopViewport();
  }

  function isStickyAtcSizeOptionOutOfStock(optionElement) {
    if (!optionElement) {
      return false;
    }

    if (optionElement.classList.contains('out-of-stock')) {
      return true;
    }

    const label = optionElement.querySelector('label');

    return label?.classList.contains('is-disabled') || label?.classList.contains('sold-out') || label?.classList.contains('disabled');
  }

  function pushStickyAtcSizeSelectEvent(event) {
    if (!isMobileViewport()) {
      return;
    }

    const sizeInput = event.target.matches('input[name="sticky-atc-size"]')
      ? event.target
      : event.target.closest('.sticky-atc-size-option')?.querySelector('input[name="sticky-atc-size"]');

    if (!sizeInput?.checked) {
      return;
    }

    const linkText = sizeInput.value?.trim();

    if (!linkText) {
      return;
    }

    const optionElement = sizeInput.closest('.sticky-atc-size-option');

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: isStickyAtcSizeOptionOutOfStock(optionElement) ? 'select_out_of_stock' : 'select_in_stock',
      element: 'button',
      position: 'tallas',
      link_text: linkText,
      url_destination: null,
    });
  }

  function getSizeOptionText(optionElement) {
    if (optionElement.matches('button[data-option-value]')) {
      return optionElement.querySelector('span')?.textContent.trim() || optionElement.textContent.trim();
    }

    const input = optionElement.htmlFor ? document.getElementById(optionElement.htmlFor) : null;

    if (input?.value) {
      return input.value.trim();
    }

    const textSpan = optionElement.querySelector('span:not(.block-swatch__color)');

    return (textSpan?.textContent || optionElement.textContent).trim();
  }

  function isSizeOptionInStock(optionElement) {
    if (optionElement.classList.contains('is-disabled') || optionElement.hasAttribute('hidden')) {
      return false;
    }

    if (optionElement.matches('label.block-swatch[data-option-value]')) {
      const input = optionElement.htmlFor ? document.getElementById(optionElement.htmlFor) : null;

      if (input?.disabled) {
        return false;
      }
    }

    return true;
  }

  function pushPdpSizeSelectEvent(event) {
    if (!isDesktopViewport()) {
      return;
    }

    const productInfo = event.target.closest('.product-info');

    if (!productInfo) {
      return;
    }

    const optionElement =
      event.target.closest('variant-picker label.block-swatch[data-option-value]') ||
      event.target.closest('variant-picker button[data-option-value]');

    if (!optionElement || !productInfo.contains(optionElement)) {
      return;
    }

    const fieldset = optionElement.closest('fieldset.variant-picker__option');

    if (!fieldset || !isSizeOptionFieldset(fieldset) || isColorOptionFieldset(fieldset)) {
      return;
    }

    const linkText = getSizeOptionText(optionElement);

    if (!linkText) {
      return;
    }

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: isSizeOptionInStock(optionElement) ? 'select_in_stock' : 'select_out_of_stock',
      element: 'button',
      position: 'tallas',
      link_text: linkText,
      url_destination: null,
    });
  }

  function getColorSwatchFromClick(event) {
    const productInfo = event.target.closest('.product-info');

    if (!productInfo) {
      return null;
    }

    const linkedSwatch = event.target.closest('.color_swatch_product_list a.color-swatch, variant-picker a.color-swatch');

    if (linkedSwatch && productInfo.contains(linkedSwatch)) {
      const fieldset = linkedSwatch.closest('fieldset');

      if (fieldset && !isColorOptionFieldset(fieldset)) {
        return null;
      }

      return {
        color: getColorNameFromSwatch(linkedSwatch),
        url: getAbsoluteUrl(linkedSwatch.getAttribute('href')),
      };
    }

    const labelSwatch = event.target.closest('variant-picker label.color-swatch[data-option-value]');

    if (labelSwatch && productInfo.contains(labelSwatch)) {
      const fieldset = labelSwatch.closest('fieldset');

      if (!fieldset || !isColorOptionFieldset(fieldset)) {
        return null;
      }

      return {
        color: getColorNameFromSwatch(labelSwatch),
        url: window.location.href,
      };
    }

    return null;
  }

  function pushColorSelectEvent(event) {
    const swatchData = getColorSwatchFromClick(event);

    if (!swatchData) {
      return;
    }

    const linkText = normalizeLinkText(swatchData.color);

    if (!linkText) {
      return;
    }

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'select_color',
      element: 'color_swatch',
      position: 'color',
      link_text: linkText,
      url_destination: getAbsoluteUrl(swatchData.url),
    });
  }

  function getProductHandle() {
    const handle =
      document.querySelector('.product-info variant-picker')?.getAttribute('handle') ||
      window.location.pathname.split('/products/')[1]?.split(/[/?#]/)[0] ||
      '';

    return normalizeLinkText(handle);
  }

  function getSelectedPdpSize() {
    const variantPicker = document.querySelector('.product-info variant-picker');

    if (!variantPicker) {
      return '';
    }

    const fieldsets = variantPicker.querySelectorAll('fieldset.variant-picker__option');

    for (const fieldset of fieldsets) {
      if (!isSizeOptionFieldset(fieldset) || isColorOptionFieldset(fieldset)) {
        continue;
      }

      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');

      if (checkedInput?.value) {
        return checkedInput.value.trim();
      }

      const hiddenInput = fieldset.querySelector('input[type="hidden"][name^="option"]');

      if (hiddenInput?.value) {
        return hiddenInput.value.trim();
      }

      const selectedButton = fieldset.querySelector('button[data-option-value][aria-selected="true"]');

      if (selectedButton?.value) {
        return selectedButton.value.trim();
      }

      const selectedOption = fieldset.querySelector('variant-option-value');

      if (selectedOption?.textContent) {
        return selectedOption.textContent.trim();
      }
    }

    return '';
  }

  function getNotifyAvailablePosition() {
    const handle = getProductHandle();
    const size = getSelectedPdpSize();

    if (handle && size) {
      return `${handle}|${size}`;
    }

    return handle;
  }

  const NOTIFY_BUTTON_SELECTORS = [
    '.restock-rocket-button',
    '.restock-rocket-button-cover',
    '.restock-rocket-button-container button',
    '.restock-rocket-button-product',
  ].join(', ');

  const NOTIFY_LINK_TEXT_FALLBACK = 'avisame_cuando_este_disponible';

  const NOTIFY_MODAL_SUBMIT_SELECTOR = '#form-Button';
  const NOTIFY_MODAL_CONTAINER_SELECTOR = '#formContainer, .restock-rocket-form-animate';

  let lastNotifyEventAt = 0;
  let lastEmailNotifyEventAt = 0;
  let notifyObserver;

  function getNotifyModalSelectedSize() {
    const select = document.querySelector('#form-Select');
    const selectedText =
      select?.options?.[select.selectedIndex]?.textContent?.trim() ||
      select?.value?.trim() ||
      '';

    if (!selectedText) {
      return getSelectedPdpSize();
    }

    const parts = selectedText.split('/');

    return (parts.length > 1 ? parts[parts.length - 1] : selectedText).trim();
  }

  function getEmailNotifyAvailablePosition() {
    const handle = getProductHandle();
    const size = getNotifyModalSelectedSize();

    if (handle && size) {
      return `${handle}|${size}`;
    }

    return handle;
  }

  function isNotifyButtonInPdpScope(notifyButton) {
    if (!notifyButton) {
      return false;
    }

    return Boolean(
      notifyButton.closest('.product-info') ||
        notifyButton.closest('.shopify-section--main-product') ||
        notifyButton.classList.contains('restock-rocket-button-product') ||
        notifyButton.closest('.restock-rocket-button-product')
    );
  }

  function matchesNotifySelector(element) {
    if (!(element instanceof Element)) {
      return false;
    }

    return element.matches(NOTIFY_BUTTON_SELECTORS) || Boolean(element.closest('.restock-rocket-button-container'));
  }

  function getNotifyButtonElement(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    if (element.matches('.restock-rocket-button')) {
      return element;
    }

    return element.closest('.restock-rocket-button') || element.closest('.restock-rocket-button-container button') || element;
  }

  function findNotifyElementFromEvent(event) {
    if (event.composedPath) {
      for (const node of event.composedPath()) {
        if (matchesNotifySelector(node)) {
          return getNotifyButtonElement(node);
        }
      }
    }

    const target = event.target instanceof Element ? event.target : null;

    if (!target) {
      return null;
    }

    if (matchesNotifySelector(target)) {
      return getNotifyButtonElement(target);
    }

    return getNotifyButtonElement(target.closest(NOTIFY_BUTTON_SELECTORS));
  }

  function getNotifyButtonText(button) {
    const directText = button?.textContent?.trim() || '';
    const containerText = button?.closest('.restock-rocket-button-container')?.textContent?.trim() || '';

    return directText || containerText;
  }

  function pushNotifyAvailableEvent(button) {
    const buttonText = getNotifyButtonText(button);
    const linkText = normalizeLinkText(buttonText) || NOTIFY_LINK_TEXT_FALLBACK;
    const position = getNotifyAvailablePosition();

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'notice_available',
      element: 'button',
      position,
      link_text: linkText,
      url_destination: null,
    });
  }

  function pushNotifyAvailableEventOnce(button) {
    const now = Date.now();

    if (now - lastNotifyEventAt < 400) {
      return;
    }

    lastNotifyEventAt = now;
    pushNotifyAvailableEvent(button);
  }

  function handleNotifyButtonInteraction(button) {
    if (!button || !isNotifyButtonInPdpScope(button)) {
      return;
    }

    pushNotifyAvailableEventOnce(button);
  }

  function matchesNotifyModalSubmitButton(element) {
    if (!(element instanceof Element)) {
      return false;
    }

    if (!element.matches(NOTIFY_MODAL_SUBMIT_SELECTOR)) {
      return false;
    }

    return Boolean(element.closest(NOTIFY_MODAL_CONTAINER_SELECTOR));
  }

  function findNotifyModalButtonFromEvent(event) {
    if (event.composedPath) {
      for (const node of event.composedPath()) {
        if (matchesNotifyModalSubmitButton(node)) {
          return node;
        }
      }
    }

    const target = event.target instanceof Element ? event.target : null;

    if (!target) {
      return null;
    }

    if (matchesNotifyModalSubmitButton(target)) {
      return target;
    }

    const button = target.closest(NOTIFY_MODAL_SUBMIT_SELECTOR);

    return button && button.closest(NOTIFY_MODAL_CONTAINER_SELECTOR) ? button : null;
  }

  function pushEmailNotifyAvailableEvent(button) {
    const linkText = normalizeLinkText(button?.textContent?.trim() || '') || NOTIFY_LINK_TEXT_FALLBACK;

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'email_notice_available',
      element: 'button',
      position: getEmailNotifyAvailablePosition(),
      link_text: linkText,
      url_destination: null,
    });
  }

  function pushEmailNotifyAvailableEventOnce(button) {
    const now = Date.now();

    if (now - lastEmailNotifyEventAt < 400) {
      return;
    }

    lastEmailNotifyEventAt = now;
    pushEmailNotifyAvailableEvent(button);
  }

  function bindNotifyModalSubmitButton(button) {
    if (!button || button.dataset.gtmEmailNotifyBound === 'true') {
      return;
    }

    button.dataset.gtmEmailNotifyBound = 'true';

    button.addEventListener(
      'click',
      function () {
        pushEmailNotifyAvailableEventOnce(button);
      },
      true
    );
  }

  function scanAndBindNotifyModalButtons(root = document) {
    root.querySelectorAll(NOTIFY_MODAL_SUBMIT_SELECTOR).forEach((button) => {
      if (button.closest(NOTIFY_MODAL_CONTAINER_SELECTOR)) {
        bindNotifyModalSubmitButton(button);
      }
    });
  }

  function bindNotifyButtonElement(element) {
    const button = getNotifyButtonElement(element);

    if (!button || button.dataset.gtmNotifyBound === 'true') {
      return;
    }

    button.dataset.gtmNotifyBound = 'true';

    button.addEventListener(
      'click',
      function () {
        handleNotifyButtonInteraction(button);
      },
      true
    );
  }

  function scanAndBindNotifyButtons(root = document) {
    root.querySelectorAll(NOTIFY_BUTTON_SELECTORS).forEach((element) => {
      bindNotifyButtonElement(element);
    });
  }

  function hookRestockRocketApi() {
    const api = window._RestockRocket;

    if (!api || api.__gtmNotifyHooked) {
      return Boolean(api?.__gtmNotifyHooked);
    }

    if (typeof api.openModal === 'function') {
      const originalOpenModal = api.openModal.bind(api);

      api.openModal = function () {
        const button = document.querySelector('.restock-rocket-button-product, .restock-rocket-button');

        handleNotifyButtonInteraction(button);
        return originalOpenModal.apply(api, arguments);
      };
    }

    api.__gtmNotifyHooked = true;
    return true;
  }

  function initNotifyButtonTracking() {
    scanAndBindNotifyButtons();
    scanAndBindNotifyModalButtons();
    hookRestockRocketApi();

    if (notifyObserver) {
      return;
    }

    notifyObserver = new MutationObserver(function (mutations) {
      hookRestockRocketApi();

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) {
            return;
          }

          if (matchesNotifySelector(node)) {
            bindNotifyButtonElement(node);
          } else {
            scanAndBindNotifyButtons(node);
          }

          if (node.matches(NOTIFY_MODAL_CONTAINER_SELECTOR) || node.querySelector(NOTIFY_MODAL_CONTAINER_SELECTOR)) {
            scanAndBindNotifyModalButtons(node);
          }
        });
      });
    });

    notifyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  initNotifyButtonTracking();
  document.addEventListener('DOMContentLoaded', initNotifyButtonTracking);
  window.addEventListener('load', initNotifyButtonTracking);

  // Extra info accordion tabs (care, shipping, materials, etc.)
  document.addEventListener(
    'click',
    function (event) {
      const summary = event.target.closest('.product-info summary');

      if (!summary) {
        return;
      }

      const accordion = summary.closest('details.accordion[is="accordion-disclosure"]');
      const blockItem = summary.closest('.product-info__block-item');

      if (!accordion || !blockItem) {
        return;
      }

      if (accordion.getAttribute('aria-expanded') === 'true') {
        return;
      }

      const linkText = getAccordionTabText(summary);

      if (!linkText) {
        return;
      }

      pushSelectContentEvent({
        event: 'select_content',
        content_type: 'pdp_section',
        action_type: 'click_on_tab',
        element: 'tabs',
        position: 'extra_info',
        link_text: linkText,
        url_destination: 'null',
      });
    },
    true
  );

  // Product gallery image zoom
  document.addEventListener('lightbox:open', function (event) {
    const gallery = event.target.closest('product-gallery');

    if (!gallery) {
      return;
    }

    const imageIndex = getGalleryImageIndex(gallery, event.detail?.index);

    pushSelectContentEvent({
      event: 'select_content',
      content_type: 'pdp_section',
      action_type: 'zoom',
      element: 'image',
      position: getImagePosition(imageIndex),
      link_text: null,
      url_destination: null,
    });
  });

  // Sizebay size links (Encuentra tu talla, Guía de tallas)
  document.addEventListener('click', function (event) {
    const sizeButton = event.target.closest('#szb-vfr-button, #szb-measurements-button');

    if (!sizeButton || !sizeButton.closest('.product-info')) {
      return;
    }

    pushSizeLinkEvent(sizeButton);
  });

  // Product color swatch selection
  document.addEventListener('click', pushColorSelectEvent, true);

  // Desktop PDP size selection (letter and numeric sizes)
  document.addEventListener('click', pushPdpSizeSelectEvent, true);

  // Mobile sticky size selection inside the size modal
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="sticky-atc-size"]')) {
      pushStickyAtcSizeSelectEvent(event);
    }
  });

  // Restock Rocket / STOQ "Notify me when available" button (step 1)
  document.addEventListener(
    'click',
    function (event) {
      const button = findNotifyElementFromEvent(event);

      if (!button) {
        return;
      }

      handleNotifyButtonInteraction(button);
    },
    true
  );

  // STOQ modal submit button (step 2)
  document.addEventListener(
    'click',
    function (event) {
      const button = findNotifyModalButtonFromEvent(event);

      if (!button) {
        return;
      }

      pushEmailNotifyAvailableEventOnce(button);
    },
    true
  );

  // Buy it with / Cómpralo con product cards
  document.addEventListener('click', pushCompraloConSelectItem, true);

  // Buy it with / Cómpralo con product list impression
  initPdpBundleViewItemListTracking();
  window.addEventListener('load', initPdpBundleViewItemListTracking);
}
